import React from 'react';
import { styled } from '@teko/ds-desktop';
import FloatingChatbot, {
  IProductChatbot,
} from 'teko-chatbot-ui/dist/index.mjs';
import { useCartV2 } from 'contexts';
import { TrackAddToCartParams } from '@teko/tracking';
import { useAuth } from '@teko/auth-react';
import { isServerless } from 'helpers';
import 'teko-chatbot-ui/dist/index.css';

interface ChatbotButtonProps {
  zaloContactLink?: string;
  terminalId?: number;
  chatbotAgentCode?: string;
  currentLng?: string;
}

const Wrapper = styled.div(
  () => `
    z-index: 1030;
`,
);

export const ChatbotButton: React.FC<ChatbotButtonProps> = ({
  zaloContactLink,
  terminalId,
  chatbotAgentCode,
  currentLng,
}) => {
  const { user, authService } = useAuth();
  const cartV2 = useCartV2();

  const addToCart = async (product: IProductChatbot) => {
    const res = await cartV2.onAddSingleItem({
      sku: product.sku,
      sellerSku: product.sellerSku,
    });
    const { trackAddToCart, AddToCartType } = await import('@teko/tracking');

    const trackAddToCartParams: TrackAddToCartParams = {
      product: {
        sku: product.sku || '',
        name: product.name || '',
        price: +product.discountPrice,
        brand: {
          name: product.brand?.name || '',
        },
        addToCartPrice: +product.price || 0,
      },
      type: AddToCartType.ADDTOCART,
    };

    if (res) {
      trackAddToCart({
        // TODO in other function
        ...trackAddToCartParams,
        status: 'success',
        cartId: res.id,
      });
    } else {
      trackAddToCart({
        ...trackAddToCartParams,
        status: 'failed',
      });
    }
  };

  const getUserId = () => {
    if (!isServerless()) return '';
    return user?.userId || window?.TekoID?.user?.getUserInfo()?.sub || '';
  };

  return isServerless() && authService.isLoggedIn() ? (
    <Wrapper>
      <FloatingChatbot
        position="relative"
        onAddToCart={addToCart}
        zaloContactLink={zaloContactLink}
        terminalId={terminalId}
        getUserId={getUserId}
        aiAgentCode={chatbotAgentCode}
        lng={currentLng}
        isUseV2
        getAccessToken={
          !window?.TekoID?.user?.getAccessToken?.()
            ? undefined
            : () => `Bearer ${window?.TekoID?.user?.getAccessToken?.()}`
        }
      />
    </Wrapper>
  ) : null;
};
